import { Box } from '@chakra-ui/react';
import React from 'react';

function CategoryTag({ catName }: TagProps) {
  return (
    <Box

      h='22px'
      p="2px 8px"
      bg="rawSienna.50"
      borderRadius="8px"
      fontSize="12px"
      fontWeight="600"
      color="rawSienna.500"
    >
      {catName}
    </Box>
  );
}

type TagProps = {
  catName: string;
};

export default CategoryTag;
